import * as React from 'react';
import CheckBox from '../Checkbox';
import Icon from '../../icons';
import ComponentVisible from '../ComponentVisible';


const AssociatedWorkkardOrgFilter = (props) => {
    const { ref, isVisible, setIsVisible } = ComponentVisible(false);
    const [isorgFilterChecked, setOrgFilterChecked]=React.useState(props.FilterValue =="0" || props.FilterValue.length > 1 ? false :true);
    const [OrgSelectOption, setOrgSelectOption] = React.useState([]);

    React.useEffect(() => {
        setInitialStateForOrgFilter();

    }, [props.FilterValue]);


    const setInitialStateForOrgFilter = () => {
        const orgFilterValue = props.FilterValue;
        const OrgSelectOption = {
            All: {
                name: '', value: '0', checked: orgFilterValue === "0" ? true : false,
                options: getFilterOption(orgFilterValue)
            }
        };
        setOrgSelectOption(OrgSelectOption);
    }


    const getFilterOption = (orgFilterValue) => {
        // const orgs = AssociatedWorkkard_ORGANIZATIONION_FILTER_ARRAY;
        const orgs = props.orgArray;
        const options = [];
        orgs.map(item => {
            options.push({ name: item.Orgname, value: item.OrgId, checked: ((orgFilterValue.includes(item.OrgId) || orgFilterValue === "0") ? true : false) })
        });
        return options;
    }

    const onChangeFilter = (parentKey, childKey) => {
        var updatedFilterOptions = OrgSelectOption;
        updatedFilterOptions[parentKey].options[childKey].checked = !updatedFilterOptions[parentKey].options[childKey].checked;
        if (!updatedFilterOptions[parentKey].options[childKey].checked) {
            updatedFilterOptions[parentKey].checked = false;
        }
        var globalCheck = updatedFilterOptions[parentKey].options.filter((e) => e.checked === false)
        if (globalCheck.length === 0) {
            updatedFilterOptions[parentKey].checked = true;
        }
         setOrgSelectOption(updatedFilterOptions);
         setOrgFilterChecked((updatedFilterOptions[parentKey].options.every(item=>item.checked==false) || updatedFilterOptions[parentKey].options.every(item=>item.checked==true))==true ? false:true);
        props.onChangeOrgFilter(updatedFilterOptions);

    }

    return (
        <div className="dropDown alignMiddle orgFilter" ref={ref} onClick={() => setIsVisible(true)}>
            <span className='alignMiddle active pointer'>
               {isorgFilterChecked  && <span className = "badges profileChecked green"></span>}
                <Icon name="filter" className="icon mr" /> <span className="orgtitle">Organization</span></span>
            {isVisible && <div className="dropDownMenu overlap openRight onClick filter">
                <div className="header">
                    <header className="alignMiddle">Organization</header>
                </div>
                {Object.keys(OrgSelectOption).map((filterKey, key) => (
                    <ul className="colFlex" key={key}>
                        {
                            OrgSelectOption[filterKey].options.slice(0, OrgSelectOption[filterKey].options.length).map((optionData, optionKey) => (
                                <li key={optionKey}>
                                    <a className="flexGrow" href="javascript:void(0)" key={optionKey}>
                                        <CheckBox handleCheckbox={() => onChangeFilter(filterKey, optionKey)}
                                           item={{id:`${optionData.name}_${optionKey}`,label:optionData.name, checked:optionData.checked === true || OrgSelectOption[filterKey].checked}} />
                                    </a>
                                </li>
                            ))
                        }
                    </ul>

                ))}
            </div>
            }
        </div>
    );
};


export default AssociatedWorkkardOrgFilter;                   